var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBlueIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43651 5L6.11614 8.57741C6.45087 8.90285 6.45087 9.43049 6.11614 9.75592C5.7814 10.0814 5.23869 10.0814 4.90395 9.75592L0.618238 5.58926C0.283504 5.26382 0.283504 4.73618 0.618238 4.41074L4.90395 0.244078C5.23869 -0.0813592 5.7814 -0.0813592 6.11614 0.244078C6.45087 0.569515 6.45087 1.09715 6.11614 1.42259L2.43651 5Z",
    fill: "#9277FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlueIndicator);
export default __webpack_public_path__ + "static/media/left-blue-indicator.2624699b1a16d0f28e610b4eae478f2c.svg";
export { ForwardRef as ReactComponent };